import {createSvgIcon} from '../create-svg-icon';

export const FlashOnIcon = createSvgIcon(
  <path d="M7 2v11h3v9l7-12h-4l3-8z" />
, 'FlashOnOutlined');
